import { render, staticRenderFns } from "./EditorView.vue?vue&type=template&id=7a8db9b5&"
import script from "./EditorView.vue?vue&type=script&lang=js&"
export * from "./EditorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports